import {TemplateList} from "~/libs/constants/TemplateList"
import {SocialListTemplateConfig} from "~/config/SocialListTemplateConfig"
import {SocialList} from "~/libs/constants/SocialList";
export const useSocialListConfig = () => {
  const getSocialList = (onlyWithUrl: boolean = false) => {
    type TemplateListKeys = keyof typeof TemplateList;
    const uniWebTemplateName:TemplateListKeys | undefined = useRuntimeConfig().public.uniWebTemplateName ? String(useRuntimeConfig().public.uniWebTemplateName).toUpperCase() as TemplateListKeys : undefined
    if (uniWebTemplateName && (uniWebTemplateName in TemplateList)) {
      const socialList = SocialListTemplateConfig[TemplateList[uniWebTemplateName]]
      if (onlyWithUrl) {
        return socialList.filter((item) => item.url)
      }
      return socialList
    }
    return []
  }


  const getSocialById = (id: SocialList) => {
    const socialList = getSocialList()
    return socialList.find(social => social.id === id)
  }

  return {
    getSocialList,
    getSocialById
  }
}


